module.exports = __webpack_public_path__ + "static/media/jack-parts.9b847914.jpg";